import { withSearch } from '@elastic/react-search-ui';
import MultiChoiceAsyncSelect from '../../../components/filter/MultiChoiceAsyncSelect';

function ResearchReportsAuthorFilter({ addFilter, removeFilter, filters }) {
  return (
    <MultiChoiceAsyncSelect
      addFilter={addFilter}
      fieldId="author"
      filters={filters}
      formHint="For example, Cathy Tyers"
      id="associated-author"
      label="Associated author"
      removeFilter={removeFilter}
    />
  );
}

export default withSearch(({ addFilter, removeFilter, filters }) => ({
  addFilter,
  removeFilter,
  filters,
}))(ResearchReportsAuthorFilter);
